import { motion } from "framer-motion";
import { useState } from "react";
import {
  DndContext,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { Space } from "antd";
import { Question } from "@types";
import { Droppable } from "../../../question-preview/common/Droppable";
import { Draggable } from "../../../question-preview/common/Draggable";

interface Props {
  question?: Question;
}

export const ConnectingOption = ({ question }: Props) => {
  const droppableIds = question?.answers.map((answer) => answer) || [];

  const [draggables, _] = useState(
    question?.answers?.map((answer) => ({
        id: answer.id,
        answer: answer.pairAnswerText,
        parent: question?.playerAnswers?.find((playerAnswer) => playerAnswer.pairAnswerText === answer.pairAnswerText)?.value || "default",
      }))
      || []
  );

  const sensors = useSensors(useSensor(PointerSensor));

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 1 }}
      style={{ width: "100%", position: "relative" }}
    >
      <DndContext sensors={sensors}>
        <Droppable key="default" id="default">
          {draggables!
            .filter((item) => item.parent === "default")
            .map((filteredItem) => (
              <Draggable key={filteredItem.id} id={filteredItem.id}>
                {filteredItem.answer}
              </Draggable>
            ))}
        </Droppable>
        <Space style={{ display: "flex", marginTop: 8 }}>
          {droppableIds.map((droppableId) => (
            <Droppable key={droppableId.value} id={droppableId.value}>
              {draggables!
                .filter((item) => item.parent === droppableId.value)
                .map((filteredItem) => (
                  <Draggable
                    key={filteredItem.id}
                    id={filteredItem.id}
                    bg={
                      filteredItem.answer === droppableId.pairAnswerText
                        ? "#dcfdba"
                        : "#fff1f0"
                    }
                  >
                    {filteredItem.answer}
                  </Draggable>
                ))}
            </Droppable>
          ))}
        </Space>
      </DndContext>
    </motion.div>
  );
};
